import { useEffect, useState } from "react";
import useAuth from "../../../hook/useAuth";
import useDelete from "../../../hook/useDelete";
import { CustomDateField } from "../../../components/CustomDateField";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import TimeInput from "../../../components/TimeInput";
import moment from "moment";
import { PleasewaitPopup } from "../../../components/PleasewaitPopup";
import axios from "axios";
import { baseURL } from "../../../config/api";

export const BlockDays = () => {
    const { auth }: any = useAuth();
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();

    const [label, setLabel] = useState<string>("");
    const [color, setColor] = useState<string>("#000000");
    const [startDate, setStartDate] = useState<string>("");
    const [startTime, setStartTime] = useState<string>("");
    const [endTime, setEndTime] = useState<string>("");
    const [isAllDay, setIsAllDay] = useState<boolean>(false);
    const [isRepeat, setIsRepeat] = useState<boolean>(false);
    const [timeSlot, setTimeSlot] = useState<string>("09-10");
    const [endRepeat, setEndRepeat] = useState<string>("After");
    const [tableData, setTableData] = useState<any[]>([]);
    const [previewRow, setPreviewRow] = useState<boolean>(false);
    const [isChanged, setIsChanged] = useState<boolean>(true);
    const [deleteItem, setDeleteItem] = useState<string[]>([]);
    const [deleteAllItem, setAllDeleteItem] = useState<boolean>(false);
    const [firstTime, setFirstTime] = useState<boolean>(true);
    const [id, setId] = useState<string>("");
    const [repeatOccur, setRepeatOccur] = useState<string>("Every Year");
    const [afterOccurrences, setAfterOccurrences] = useState<string>("");
    const [ondate, setOndate] = useState<string>("");
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(true);

    const handleFormSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        setPleaseWaitPopup(true);

        if (id) {
            await axios
                .put(
                    `${baseURL}blockedDays?userId=${auth?.id}`,
                    JSON.stringify({
                        id,
                        name: label,
                        color,
                        startDate,
                        isAllDay,
                        timeSlot: isAllDay ? "" : timeSlot,
                        startTime: isAllDay ? "" : startTime,
                        endTIme: isAllDay ? "" : endTime,
                        repeat: isRepeat,
                        repeatOccur: isRepeat ? repeatOccur : "",
                        endrepeat: endRepeat,
                        afterOccurrences: isRepeat ? afterOccurrences : "",
                        ondate: isRepeat ? ondate : "",
                    }),
                    {
                        headers: { "Content-Type": "application/json" },
                        withCredentials: false,
                    }
                )
                .then(() => {
                    setId("");
                    setLabel("");
                    setColor("#000000");
                    setStartDate("");
                    setStartTime("");
                    setEndTime("");
                    setIsAllDay(false);
                    setIsRepeat(false);
                    setTimeSlot("");
                    setRepeatOccur("Every Year");
                    setEndRepeat("");
                    setAfterOccurrences("After");
                    setOndate("");
                    setIsChanged(true);
                    setAllDeleteItem(false);
                    setPreviewRow(false);
                })
                .catch((error) => {
                    console.error(error)
                });
        } else {
            await axios
                .post(
                    `${baseURL}blockedDays?userId=${auth?.id}`,
                    JSON.stringify({
                        name: label,
                        color,
                        startDate,
                        isAllDay,
                        timeSlot: isAllDay ? "" : timeSlot,
                        startTime: isAllDay ? "" : startTime,
                        endTIme: isAllDay ? "" : endTime,
                        repeat: isRepeat,
                        repeatOccur: repeatOccur,
                        endrepeat: endRepeat,
                        afterOccurrences: isRepeat ? afterOccurrences : "",
                        ondate: isRepeat ? ondate : "",
                    }),
                    {
                        headers: { "Content-Type": "application/json" },
                        withCredentials: false,
                    }
                )
                .then(() => {
                    setLabel("");
                    setColor("#000000");
                    setStartDate("");
                    setStartTime("");
                    setEndTime("");
                    setIsAllDay(false);
                    setIsRepeat(false);
                    setTimeSlot("");
                    setRepeatOccur("Every Year");
                    setEndRepeat("");
                    setAfterOccurrences("After");
                    setOndate("");
                    setIsChanged(true);
                    setAllDeleteItem(false);
                    setPreviewRow(false);
                })
                .catch((error) => {
                    setPleaseWaitPopup(false);
                    console.error(error)
                });
        }
    };

    useEffect(() => {
        if (isChanged) {
            axios
                .get(`${baseURL}blockedDays`)
                .then((response) => {
                    setTableData(() => response.data);
                    setIsChanged(false);
                    setPleaseWaitPopup(false);
                })
                .catch((error) => {
                    setIsChanged(false);
                    setPleaseWaitPopup(false);
                    console.error("Error:", error);
                });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isChanged]);

    useEffect(() => {
        if (!firstTime) {
            if (!deleteAllItem) {
                setDeleteItem([]);
            } else {
                setDeleteItem(() =>
                    tableData.map((item: any) => {
                        return item.id;
                    })
                );
            }
        }

        setFirstTime(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [deleteAllItem]);

    const deleteSelectedItem = async () => {
        setDeleteData({
            tilte: `Delete`,
            summary: `Are you sure you want to delete this Blocked Day?`,
            isDelete: (callback: any) => {
                Promise.all(
                    deleteItem?.map((item: string) =>
                        axios.delete(`${baseURL}blockedDays?id=${item}&userId=${auth?.id}`)
                    )
                )
                    .then(() => {
                        setIsChanged(true);
                        setAllDeleteItem(false);
                        setPleaseWaitPopup(true);
                        setDeleteItem([]);
                    })
                    .catch((error) => {
                        setIsChanged(true);
                        setAllDeleteItem(false);
                        setPleaseWaitPopup(true);
                        console.error(error)
                    });

                callback();
            }
        });

        setDeletePopup(true);
    };

    const editTheData = (primaryKey: string) => {
        setId(primaryKey);

        axios
            .get(`${baseURL}blockedDays/${primaryKey}`)
            .then((response) => {
                setLabel(response.data.name);
                setColor(response.data.color);
                setStartDate(response.data.startDate.split("T")[0]);
                setIsAllDay(response.data.isAllDay);
                setTimeSlot(response.data.timeSlot);
                setStartTime(response.data.startTime);
                setEndTime(response.data.endTIme);
                setIsRepeat(response.data.repeat);
                setEndRepeat(response.data.endRepeat);
                setRepeatOccur(response.data.repeatOccur);
                setAfterOccurrences(response.data.afterOccurrences);
                setOndate(response.data.ondate.split("T")[0]);
            })
            .catch((error) => {
                console.error(error)
            });
    };

    const onCancel = () => {
        setId("");
        setLabel("");
        setColor("#000000");
        setStartDate("");
        setStartTime("");
        setEndTime("");
        setIsAllDay(false);
        setIsRepeat(false);
        setTimeSlot("");
        setRepeatOccur("Every Year");
        setEndRepeat("");
        setAfterOccurrences("After");
        setOndate("");
        setAllDeleteItem(false);
    };

    return (
        <>
            <div className={` px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
                <div className={`bg-white w-full rounded-lg p-4 flex flex-col gap-2.51`}>
                    <h2 className={`text-lg font-semibold`}>Blocked Days</h2>

                    <hr />

                    <div className={`w-full flex flex-row pt-2.5 px-2 border-b`}>
                        <div className={`w-2/5 mr-3 border-b pb-2`}>
                            <h2 className={`text-sm m-0`}>
                                {id ? "Edit" : "Add New"} Scheduling
                            </h2>

                            <hr />

                            <form onSubmit={(e) => handleFormSubmit(e)} className="w-full grid grid-cols-2 gap-x-[2rem] gap-y-4 mt-2">
                                <div>
                                    <label className={`text-xs font-medium text-secondary`}>Label</label>
                                    <input
                                        type="text"
                                        className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                        value={label}
                                        onChange={(e) => setLabel(e.target.value)}
                                        required
                                    />
                                </div>

                                <div className="flex flex-col">
                                    <label className={`text-xs font-medium text-secondary`}>Color</label>
                                    <input
                                        type="color"
                                        name="color"
                                        style={{
                                            fontSize: "14px",
                                        }}
                                        value={color}
                                        onChange={(e) => setColor(e.target.value)}
                                    />
                                </div>

                                <div>
                                    <label className={`text-xs font-medium text-secondary`}>Start Date</label>
                                    <CustomDateField
                                        value={startDate}
                                        onChange={setStartDate}
                                        required={true}
                                        className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                    />
                                </div>

                                <div>
                                    <label className={`text-xs font-medium text-secondary`}>All Day?</label>
                                    <RadioGroup
                                        row
                                        value={isAllDay ? "Yes" : "No"}
                                        onChange={(e) => setIsAllDay(e.target.value === "Yes" ? true : false)}
                                    >
                                        <FormControlLabel
                                            value="Yes"
                                            control={
                                                <Radio
                                                    sx={{
                                                        color: "gray",
                                                        "&.Mui-checked": {
                                                            color: "blue",
                                                        },
                                                    }}
                                                />
                                            }
                                            label="Yes"
                                            sx={{
                                                color: "#2f3739",
                                            }}
                                        />

                                        <FormControlLabel
                                            value="No"
                                            control={
                                                <Radio
                                                    sx={{
                                                        color: "gray",
                                                        "&.Mui-checked": {
                                                            color: "blue",
                                                        },
                                                    }}
                                                />
                                            }
                                            label="No"
                                            sx={{
                                                color: "#2f3739",
                                            }}
                                        />
                                    </RadioGroup>
                                </div>

                                {
                                    !isAllDay
                                    && (
                                        <>
                                            <div>
                                                <label className={`text-xs font-medium text-secondary`}>Time Slot</label>
                                                <select
                                                    className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                    value={timeSlot}
                                                    onChange={(e) => setTimeSlot(e.target.value)}
                                                >
                                                    <option value="09-10">09-10</option>
                                                    <option value="10-11">10-11</option>
                                                    <option value="11-12">11-12</option>
                                                    <option value="12-13">12-13</option>
                                                    <option value="13-14">13-14</option>
                                                    <option value="14-15">14-15</option>
                                                    <option value="15-16">15-16</option>
                                                    <option value="16-17">16-17</option>
                                                    <option value="17-18">17-18</option>
                                                    <option value="18-19">18-19</option>
                                                    <option value="19-20">19-20</option>
                                                </select>
                                            </div>

                                            <div />

                                            <div>
                                                <label className={`text-xs font-medium text-secondary`}>Start Time</label>
                                                <TimeInput
                                                    name={"startTime"}
                                                    value={startTime}
                                                    setValue={setStartTime}
                                                    required={true}
                                                />
                                            </div>

                                            <div>
                                                <label className={`text-xs font-medium text-secondary`}>End Time</label>
                                                <TimeInput
                                                    name={"endTime"}
                                                    value={endTime}
                                                    setValue={setEndTime}
                                                    required={true}
                                                />
                                            </div>
                                        </>
                                    )
                                }

                                <div className="col-span-2">
                                    <label className={`text-xs font-medium text-secondary`}>Repeat?</label>
                                    <RadioGroup
                                        row
                                        value={isRepeat ? "Yes" : "No"}
                                        onChange={(e) => setIsRepeat(e.target.value === "Yes")}
                                    >
                                        <FormControlLabel
                                            value="Yes"
                                            control={
                                                <Radio
                                                    sx={{
                                                        color: "gray",
                                                        "&.Mui-checked": {
                                                            color: "blue",
                                                        },
                                                    }}
                                                />
                                            }
                                            label="Yes"
                                            sx={{
                                                color: "#2f3739",
                                            }}
                                        />

                                        <FormControlLabel
                                            value="No"
                                            control={
                                                <Radio
                                                    sx={{
                                                        color: "gray",
                                                        "&.Mui-checked": {
                                                            color: "blue",
                                                        },
                                                    }}
                                                />
                                            }
                                            label="No"
                                            sx={{
                                                color: "#2f3739",
                                            }}
                                        />
                                    </RadioGroup>
                                </div>

                                {
                                    isRepeat
                                    && (
                                        <>
                                            <div>
                                                <label className={`text-xs font-medium text-secondary`}>Repeats</label>
                                                <select
                                                    className={`w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-[#167AC3] text-sm text-secondary bg-transparent`}
                                                    value={repeatOccur}
                                                    onChange={(e) => setRepeatOccur(e.target.value)}
                                                >
                                                    <option value="Every Year">Every Year</option>
                                                    <option value="Every Month">Every Month</option>
                                                    <option value="Every Week">Every Week</option>
                                                    <option value="Every Day">Every Day</option>
                                                </select>
                                            </div>

                                            <div />

                                            <div>
                                                <label className={`text-xs font-medium text-secondary`}>End Repeat</label>
                                                <select
                                                    className={`w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-[#167AC3] text-sm text-secondary bg-transparent`}
                                                    value={endRepeat}
                                                    onChange={(e) => setEndRepeat(e.target.value)}
                                                >
                                                    <option value="After">After</option>
                                                    <option value="On Date">On Date</option>
                                                </select>
                                            </div>

                                            {
                                                endRepeat === "After"
                                                    ? (
                                                        <div>
                                                            <label className={`text-xs font-medium text-secondary`}>After Occurrences</label>
                                                            <input
                                                                type="text"
                                                                className={`w-full px-[8px] py-[6px] border rounded-md border-secondary outline-none focus:border-[#167AC3] text-sm text-secondary bg-transparent`}
                                                                value={afterOccurrences}
                                                                onChange={(e) => setAfterOccurrences(e.target.value)}
                                                                required
                                                            />
                                                        </div>
                                                    ) : (
                                                        <div>
                                                            <label className={`text-xs font-medium text-secondary`}>On Dates</label>
                                                            <CustomDateField
                                                                value={ondate}
                                                                onChange={setOndate}

                                                            />
                                                        </div>
                                                    )
                                            }
                                        </>
                                    )
                                }

                                <div className="flex gap-2.5">
                                    {
                                        id
                                            ? (
                                                <button
                                                    type="button"
                                                    onClick={() => onCancel()}
                                                    className="w-full sm:w-auto px-4 py-2 rounded bg-[#FFFFFF] text-primary cursor-pointer border border-primary"
                                                >
                                                    Cancel
                                                </button>
                                            ) : (
                                                <button
                                                    onClick={() => setPreviewRow(!previewRow)}
                                                    className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                                >
                                                    Preview
                                                </button>
                                            )
                                    }

                                    <button
                                        type="submit"
                                        onClick={() => setPreviewRow(!previewRow)}
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                    >
                                        {id ? "Update" : "Save"}
                                    </button>
                                </div>
                            </form>
                        </div>

                        <div className="w-3/5 px-2">
                            <div>
                                <div className="flex justify-between items-center pb-2">
                                    <h2 className={`text-sm m-0`}>
                                        Blocked Dates
                                    </h2>

                                    <button
                                        type="button"
                                        onClick={deleteSelectedItem}
                                        disabled={!deleteItem?.length}
                                        className={`w-full sm:w-auto px-4 py-2 rounded ${!deleteItem?.length ? "bg-gray-200 text-gray-400" : "bg-red-500 text-white border-red-600"} cursor-pointer border`}
                                    >
                                        Delete Selected
                                    </button>
                                </div>

                                <hr />

                                <table className="min-w-full border border-collapse text-xs">
                                    <thead className={`bg-[#F9FAFB]`}>
                                        <tr>
                                            <th className={`p-2 text-left text-black-rgba border`}>
                                                <input
                                                    type="checkbox"
                                                    checked={deleteAllItem}
                                                    onChange={() => setAllDeleteItem(() => !deleteAllItem)}
                                                />
                                            </th>
                                            <th className={`p-2 text-left text-black-rgba border`}>Label</th>
                                            <th className={`p-2 text-left text-black-rgba border`}>Color</th>
                                            <th className={`p-2 text-left text-black-rgba border`}>Starts At</th>
                                            <th className={`p-2 text-left text-black-rgba border`}>Ends At</th>
                                            <th className={`p-2 text-left text-black-rgba border`}>Status</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {
                                            tableData?.map((item: any) => {
                                                return (
                                                    <tr key={item.id} className="border">
                                                        <td className={`p-2 border text-black-rgba`}>
                                                            <input
                                                                type="checkbox"
                                                                checked={deleteItem.includes(item.id)}
                                                                onChange={() => {
                                                                    const updated = deleteItem.includes(item.id)
                                                                        ? deleteItem.filter((id: string) => id !== item.id)
                                                                        : [...deleteItem, item.id];
                                                                    setDeleteItem(updated);
                                                                }}
                                                            />
                                                        </td>

                                                        <td className={`p-2 border text-blue-600 cursor-pointer hover:underline`}
                                                            onClick={() => editTheData(item?.id)}>
                                                            {item.name}
                                                        </td>

                                                        <td className="p-2 border">
                                                            <div className="rounded" style={{ backgroundColor: item.color, padding: "10px 8px" }} />
                                                        </td>

                                                        <td className="p-2 border text-black-rgba">
                                                            {
                                                                moment(
                                                                    item?.startTime
                                                                        ? `${item?.startDate?.split("T")[0]}T${item?.startTime}`
                                                                        : item?.startDate
                                                                ).format("MM/DD/YYYY hh:mm A")
                                                            }
                                                        </td>

                                                        <td className="p-2 border text-black-rgba">
                                                            {
                                                                moment(
                                                                    item?.endTIme
                                                                        ? `${item?.startDate?.split("T")[0]}T${item?.endTIme}`
                                                                        : item?.startDate
                                                                ).format("MM/DD/YYYY hh:mm A")
                                                            }
                                                        </td>
                                                        <td className={`p-2 border text-black-rgba`}>Closed</td>
                                                    </tr>
                                                )
                                            })
                                        }

                                        {
                                            previewRow && (
                                                <tr className="border">
                                                    <td className="p-2 border">
                                                        <input type="checkbox" />
                                                    </td>

                                                    <td className={`p-2 border text-black-rgba`}>{label}</td>

                                                    <td className="p-2 border">
                                                        <div className="rounded" style={{ backgroundColor: color, padding: "10px 8px" }} />
                                                    </td>

                                                    <td className="p-2 border text-black-rgba">
                                                        {
                                                            startTime &&
                                                            moment(`${startDate}T${startTime}`).format("MM/DD/YYYY hh:mm A")
                                                        }
                                                    </td>

                                                    <td className="p-2 border text-black-rgba">
                                                        {
                                                            endTime &&
                                                            moment(`${startDate}T${endTime}`).format("MM/DD/YYYY hh:mm A")
                                                        }
                                                    </td>

                                                    <td className={`p-2 border text-black-rgba`}>Closed</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <PleasewaitPopup showPopup={pleaseWaitPopup} />
        </>
    )
}